export const formatVisitNumber = (visit?: { id?: number; visit_number?: string | null } | null) => {
  if (!visit) return "-";
  const visitNumber = String(visit.visit_number || "").trim();
  if (!visitNumber) return String(visit.id || "-");
  const parts = visitNumber.split("-");
  return parts[parts.length - 1] || visitNumber;
};

export const formatVisitLabel = (visit?: { id?: number; visit_number?: string | null } | null) => {
  return `Visit #${formatVisitNumber(visit)}`;
};
